{
  "dropzoneLabel": "Strefa upuszczania",
  "selectPlaceholder": "Wybierz element",
  "tableResizer": "Zmiana rozmiaru",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
